<nav class="navbar navbar-expand-md navbar-light">
	<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#liosNavBar"
		aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		<span class="navbar-toggler-icon"></span>
	</button>

	<div class="menu-group collapse navbar-collapse" id="liosNavBar">
		<mat-nav-list class="inline">
			<!-- <a mat-list-item id="menuItem" class="menu-item" *ngFor="let menuItem of menuItems">
				{{ menuItem.displayName }}
			</a> -->
		</mat-nav-list>

		<!-- <div class="inline">
			<a id="menuItem" class="menu-item" *ngFor="let menuItem of menuItems">
				{{ menuItem.displayName }}
			</a>
		</div> -->
	</div>
</nav>